<template>
  <div class="container" id="top-page">
    <div style="height: 100vh">
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right> mdi-menu-down </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="events"
              :event-color="getEventColor"
              :type="type"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-toolbar-title
                    v-html="selectedEvent.title"
                  ></v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon>
                    <v-icon>mdi-heart</v-icon>
                  </v-btn> -->
                  <v-btn icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <span v-html="selectedEvent.details"> </span>
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="secondary" @click="selectedOpen = false">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Service Jobs</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <tableComponent
            :tableHeaders="jobHeader"
            :tableItems="jobListFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.$refs.calendar.checkChange();
        this.panel = Array.from(Array(2).keys());
        this.getBAQServiceJobs();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      jobHeader: [
        { text: "Start Date", value: "JobHead_StartDate" },
        { text: "Due Date", value: "JobHead_DueDate" },
        { text: "Job Number", value: "JobHead_JobNum" },
        { text: "Service Call", value: "FSCallDt_CallNum" },
        { text: "Call Line", value: "FSCallDt_CallLine" },
        { text: "Part", value: "JobHead_PartNum" },
        { text: "Part Description", value: "JobHead_PartDescription" },
        { text: "Priority", value: "SchedPri_Description" },
        { text: "Equipment ID", value: "JobHead_EquipID" },
        { text: "Serial Number", value: "FSCallDt_SerialNumber" },
        { text: "Issue Description", value: "JobHead_IssueTopics" },
        { text: "Status", value: "Status" },
      ],
      panel: [],
      jobList: [],
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
      focus: "",
      type: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: [
        "#0187d9",
        "#a2d183",
        "#f4cb6b",
        "#008baa",
        "#f8811c",
        "#6e7b83",
      ],
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getJobListBoard() {
      this.loadJobs();
    },
    getOpenCall() {
      this.getEvents();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getJobListBoard", "getOpenCall"]),
    jobListFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.jobList == null || filterKey === "") return this.jobList;
      return this.jobList.filter((i) => {
        return (
          i.JobHead_JobNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.JobHead_IssueTopics.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.FSCallDt_SerialNumber.toString().toLowerCase().indexOf(filterKey) >
            -1
        );
      });
    },
    jobListFilterDate() {
      if (this.jobList.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.jobListFilter.filter((i) => {
          let day = i.JobHead_StartDate.split("/")[0];
          let month = i.JobHead_StartDate.split("/")[1];
          let year = i.JobHead_StartDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.jobListFilter;
      }
    },
  },
  methods: {
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQServiceJobs() {
      await this.$store.dispatch("Data/getOpenCallData");
      await this.$store.dispatch("Data/getJobListBoard");
      this.loadJobs();
    },
    loadJobs() {
      this.jobList = [];
      if (this.getJobListBoard && this.getJobListBoard.length > 0) {
        this.getJobListBoard.forEach((el) => {
          this.jobList.push({
            ...el,
            JobHead_StartDate: this.convertDate(el.JobHead_StartDate),
            JobHead_DueDate: this.convertDate(el.JobHead_DueDate),
            JobHead_JobNum: el.JobHead_JobNum,
            JobHead_IssueTopics: el.JobHead_IssueTopics,
            FSCallDt_SerialNumber: el.FSCallDt_SerialNumber,
            JobHead_EquipID: el.JobHead_EquipID,
            SchedPri_Description: el.SchedPri_Description,
            Status:
              el.JobHead_JobClosed == false
                ? "OPEN"
                : el.JobHead_JobClosed == true
                ? "CLOSED"
                : "",
            FSCallDt_CallNum: el.FSCallDt_CallNum,
            FSCallDt_CallLine: el.FSCallDt_CallLine,
            JobHead_PartNum: el.JobHead_PartNum,
            JobHead_PartDescription: el.JobHead_PartDescription,
          });
        });
      }
    },
    getEvents() {
      const events = [];
      if (this.getOpenCall && this.getOpenCall.length > 0)
        this.getOpenCall.forEach((el) => {
          if (el.FSCallhd_SchedTime) {
            const s = parseInt(el.FSCallhd_SchedTime);
            var result = new Date(s * 1000).toISOString().slice(11, 19);

            const first = new Date(
              el.FSCallhd_SchedDate.split("T")[0] + "T" + result
            );

            const second = new Date(
              el.FSCallhd_SchedDate.split("T")[0] + "T" + result
            );
            let duration =
              parseInt(el.FSCallhd_Duration) == 1
                ? el.FSCallhd_Duration + " Day"
                : el.FSCallhd_Duration + " Days";
            events.push({
              name: "Call:" + el.FSCallhd_CallNum + "-Job:" + el.JobHead_JobNum,
              title:
                "Call:" + el.FSCallhd_CallNum + "</br>Job:" + el.JobHead_JobNum,
              start: first,
              end: second,
              color: this.colors[this.rnd(0, this.colors.length - 1)],
              timed: true,
              details:
                "Technician: " +
                el.FsTech_Name +
                "</br>Scheduled Date: " +
                this.convertDate(el.FSCallhd_SchedDate) +
                "</br>Scheduled Time: " +
                result +
                "</br>Duration: " +
                duration +
                "</br>Part Num: " +
                el.FSCallDt_PartNum +
                "</br>Issue Description: " +
                el.FSCallDt_PartDescription +
                "</br>Serial Number: " +
                el.FSCallDt_SerialNumber +
                "</br>Call Type: " +
                el.FSCallCd_CallDescription +
                "</br>Priority: " +
                el.FSCallhd_CallPriority +
                "</br>Case Number: " +
                el.FSCallhd_HDCaseNum +
                "</br>PONum: " +
                el.FSCallhd_PONum +
                "</br>Comments: " +
                el.FSCallhd_CallComment,
            });
          }
        });
      // for (let i = 0; i < eventCount; i++) {
      //   const allDay = this.rnd(0, 3) === 0
      //   const firstTimestamp = this.rnd(min.getTime(), max.getTime())
      //   const first = new Date(firstTimestamp - (firstTimestamp % 900000))
      //   const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
      //   const second = new Date(first.getTime() + secondTimestamp)

      //   events.push({
      //     name: this.names[this.rnd(0, this.names.length - 1)],
      //     start: first,
      //     end: second,
      //     color: this.colors[this.rnd(0, this.colors.length - 1)],
      //     timed: false,
      //   })
      // }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange() {
      const events = [];
      if (this.getOpenCall && this.getOpenCall.length > 0)
        this.getOpenCall.forEach((el) => {
          if (el.FSCallhd_SchedTime) {
            const s = parseInt(el.FSCallhd_SchedTime);
            var result = new Date(s * 1000).toISOString().slice(11, 19);

            const first = new Date(
              el.FSCallhd_SchedDate.split("T")[0] + "T" + result
            );

            const second = new Date(
              el.FSCallhd_SchedDate.split("T")[0] + "T" + result
            );
            let duration =
              parseInt(el.FSCallhd_Duration) == 1
                ? el.FSCallhd_Duration + " Day"
                : el.FSCallhd_Duration + " Days";
            events.push({
              name: "Call:" + el.FSCallhd_CallNum + "-Job:" + el.JobHead_JobNum,
              title:
                "Call:" + el.FSCallhd_CallNum + "</br>Job:" + el.JobHead_JobNum,
              start: first,
              end: second,
              color: this.colors[this.rnd(0, this.colors.length - 1)],
              timed: true,
              details:
                "Technician: " +
                el.FsTech_Name +
                "</br>Scheduled Date: " +
                this.convertDate(el.FSCallhd_SchedDate) +
                "</br>Scheduled Time: " +
                result +
                "</br>Duration: " +
                duration +
                "</br>Part Num: " +
                el.FSCallDt_PartNum +
                "</br>Issue Description: " +
                el.FSCallDt_PartDescription +
                "</br>Serial Number: " +
                el.FSCallDt_SerialNumber +
                "</br>Call Type: " +
                el.FSCallCd_CallDescription +
                "</br>Priority: " +
                el.FSCallhd_CallPriority +
                "</br>Case Number: " +
                el.FSCallhd_HDCaseNum +
                "</br>PONum: " +
                el.FSCallhd_PONum +
                "</br>Comments: " +
                el.FSCallhd_CallComment,
            });
          }
        });
      this.events = events;
    },
  },
};
</script>

<style scoped>
.v-btn:not(.v-btn--outlined).primary,
.v-btn:not(.v-btn--outlined).secondary,
.v-btn:not(.v-btn--outlined).accent,
.v-btn:not(.v-btn--outlined).success,
.v-btn:not(.v-btn--outlined).error,
.v-btn:not(.v-btn--outlined).warning,
.v-btn:not(.v-btn--outlined).info {
  color: black;
}

.ml-20 {
  margin-left: 100px;
}

.input_date {
  outline: #d1dfe3;
}

.filter_date {
  display: flex;
  flex-direction: row;
}

.filter_date_item {
  display: flex;
  flex-direction: column;
}

.mb-20 {
  margin-bottom: 50px;
}

.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}

::v-deep .v-present .v-btn {
  background-color: #99d9f2 !important;
  color: black !important;
}

.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.input-search {
  margin-top: 5px;
  margin-bottom: 5px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}

.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}
</style>
